module.exports = __webpack_public_path__ + "h5/img/cs_06.89246db2.jpeg";